module.exports = __webpack_public_path__ + "static/img/DSC_0041.bc9668e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/DSC_0041.jpg
// module id = QMjE
// module chunks = 0